<style>
    .overflow-hidden { overflow: hidden; }
    .outer { position: relative; left: 50%; float: left; }
    .inner { position: relative; left: -50%; float: left; }
    .hidden {
        display: none;
    }

    .log-table thead th, .log-table tbody td{
        padding: 0 .75rem;
        vertical-align: middle;
        border: none;
    }
    .log-table tr {
        border-top: 1px solid #91ccda;
        padding: 16px;
    }
    .log-table tr:first-child {
        border-top: none;
    }

    .log-table tr:hover {
        background-color: #ebf5f8;
    }

    .log-table tr td {
        color: #223264;
        border: none;
    }

    .log-table tr.table-details {
        border-top: 0px;
        border-bottom: solid 1px #91ccda;
    }
    .log-table tr.table-details:last-child {
        border-bottom: none;
    }

    .log-table tr.table-details:hover,
    .log-table tr.table-has-details:hover {
        background-color: transparent;
    }

    .log-table tr td {
        cursor: pointer;
    }
    .log-table tr.table-details td {
        cursor: initial;
    }

    #main_content .log-table td p {
        font-size: 16px;
    }

    .smaller-icon-container {
        font-size: .725em;        
    }
</style>

<template>
    <div class="component-container">
        <div class="log-table table-responsive">
            <data-table
                :items="logs"
                :fields="fields"
                empty-text="There are no activity logs for this childcare program"
                :show-search-input="true"
                :show-items-per-page-select="true"
                :show-details-row="true"
            >
                <template #type="{ item }">
                    <strong>{{ item.type.name }}</strong>
                </template>
                <template #user="{ item }">
                    {{ item.user.first_name }} {{item.user.last_name}}
                </template>
                <template #date="{ item }">
                    {{ formatDate(item.date) }}
                </template>
                <template #show_details="{ item, toggleDetails }">
                    <div class="col text-right">
                        <div class="smaller-icon-container" v-show="!toggleDetails?.[item.id]">
                            <span class="fa fa-plus"></span>
                        </div>
                        <div class="smaller-icon-container" v-show="toggleDetails?.[item.id]">
                            <span class="fa fa-minus"></span>
                        </div>
                    </div>
                </template>
                <template #row_details="{ item }">
                        <div class="details" colspan="4">
                            <p>Time Spent: <strong>{{item.time_spent}} minutes</strong></p>
                            <p>Areas Covered: <strong>{{item.areaString}}</strong></p>
                            <p>{{item.notes}}</p>
                            <button type="button" class="btn btn-orange-blue" v-on:click="assignLog(item)" data-toggle="modal" data-target="#activityLogFormModal">
                                Edit
                            </button>
                        </div>
                </template>
            </data-table>
        </div>
    </div>
</template>

<script>
    import { mapWritableState } from 'pinia'
    import { useConsultantsStore } from './store.js';
    import DataTable from '../DataTable.vue';

    export default {
        props: {
            logs: {
                required: true,
                type: Array
            }
        },
        components: {
            DataTable
        },
        data() {
            return {
                fields: [
                    {
                        key: 'type',
                        thStyle: {
                            width: '40%'
                        },
                        label: 'Type',
                    }, 
                    {
                        key: 'user',
                        thStyle: {
                            width: '20%'
                        },
                        label: 'User',
                    }, 
                    {
                        key: 'date',
                        thStyle: {
                            width: '20%'
                        },
                        label: 'Date',
                    }, 
                    {
                        key: 'show_details',
                        label: ''
                    }
                ],
                // toggleDetails: {}
            }
        },
        methods: {
            formatDate(dateString, format = 'MM/DD/YYYY') {
                if (moment(dateString).isValid()) {
                    return moment(dateString).utc().format(format)
                }
                return null
            },
            assignLog(log) {
                this.currentLog = {...this.currentLog, ...log};
            },
        },
        computed: {
            ...mapWritableState(useConsultantsStore, {
                currentLog: 'log',
            }),
        },
        mounted() {
        }
    }
</script>